
import { Vue, Component, Prop } from 'vue-property-decorator';
import ClickOutside from 'vue-click-outside';

@Component({
	directives: {
		ClickOutside,
	},
})
export default class CustomTooltip extends Vue {
	@Prop({ type: String, default: '' }) readonly tooltipClasses: string;
	@Prop() TooltipStyle;
	@Prop() contentStyle;

	isTooltipVisible = false;

	clickTooltip() {
		this.isTooltipVisible = !this.isTooltipVisible;
	}
	clickAway() {
		this.isTooltipVisible = false;
	}
}
